
        <div class="cover">
            <div class="frown"><i class="far fa-frown-open"></i></div>
            <h1 class="my-5">{{ error.getName() }}</h1>
            <div class="message">{{ error.message }}</div>
            <div class="actions mt-5">
                <a (click)="logout()" *ngIf="error.capabilities.logout"
                    >Logout</a
                >
                <a (click)="retry()" *ngIf="error.capabilities.retry">Retry</a>
            </div>
        </div>
    